import { styled } from 'styled-components';

import { Box } from '#/components/Box/Box';
import { Body } from '#/components/Text/Body';
import type { CmsApiBlockquoteBlockData } from '#/modules/cms/api/types/blocks/CmsApiBlockquoteBlock';
import { colors, cssBreakpoints, gutterWidth, spacing } from '#/theme/theme';

type Props = {
  blockIndex: number;
  data: CmsApiBlockquoteBlockData;
  className?: string;
};

export const CmsBlockquoteBlock = styled(
  ({ blockIndex, data: { quote, cite, style }, className }: Props) => (
    <div>
      <Box
        borderRadius={[0, 0, 0, 10]}
        bg={colors.backgroundGrey}
        className={className}
      >
        <Box
          pt={gutterWidth}
          pb={[gutterWidth / 2]}
          textAlign={style === 'QUOTE' ? 'center' : 'left'}
        >
          <Body
            analyticsData={{
              eventName: 'CMS Block',
              eventProperties: {
                block_position: blockIndex,
                block_type: 'Block Quote',
              },
            }}
            styleAs={quote.length > 225 ? 'body' : 'bodyLarge'}
            dangerouslySetInnerHTML={{
              __html: quote,
            }}
          />
          {cite && (
            <Box mt="18px">
              <Body>{cite}</Body>
            </Box>
          )}
        </Box>
      </Box>
    </div>
  ),
)`
  position: relative;
  margin-left: -${spacing[24]};
  padding: 0 ${spacing[24]};
  width: 100vw;

  *:first-child {
    margin-top: 0;
  }

  *:last-child {
    margin-bottom: 0;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    width: 100%;
    margin-left: 0;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    padding: 0 48px;
  }

  ${(props) =>
    props.data.style === 'QUOTE' &&
    `
      &::before {
        content: '“';
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -35%);
        color: ${colors.brandYellow};
        font-size: 100px;
        font-weight: 700;
        line-height: 1;
    }
  `}
  ${(props) =>
    props.data.style === 'CALLOUT' &&
    `
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 36px;
        left: 48px;
        background-color: ${colors.brandYellow};
        height: 4px;
        width: 70px;
        }

        @media all and (max-width: ${cssBreakpoints.smDown}) {
          &::before {
            left: 24px;
            height: 3px;
          }
        }
  `}
`;
